import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = { class: "tip-info" }
const _hoisted_3 = { class: "dialog-footer" }

import {
  computed,
  ref,
  PropType,
  watch,
  nextTick,
  toRaw,
  reactive,
} from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { upsertCard, upsertGroup } from '@/api/operation'
import { ElInput } from 'element-plus'
import { ElMessage } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import useFormRules from '@/hooks/useFormRules'
import SelectOperator from '@/components/SelectOperator.vue'
import { Group, PricingDescountInfoType } from '@/types/types'
import FormRulesFactory from '@/common/formRules'


import _ from 'lodash'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'GroupUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  info: {
    type: Object as PropType<Partial<Group>>,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { t } = useI18n()

let groupFormRule = reactive({
  ...FormRulesFactory.generateCustomRules(
    ['evseOperatorId', 'type', 'priceingType'],
    'selectNone',
    'selectNone',
    {
      removeZeroCheck: true,
    },
  ),
  ...FormRulesFactory.generateCustomRules(['name', 'phone'], 'inputEmpty', 'inputInvalid'),
  ...FormRulesFactory.generateCustomRules(
    [
      'sharpElecAmount',
      'sharpServiceAmount',
      'peakElecAmount',
      'peakServiceAmount',
      'flatElecAmount',
      'flatServiceAmount',
      'valleyElecAmount',
      'valleyServiceAmount',
      'deepValleyElecAmount',
      'deepServiceAmount',
    ],
    'inputEmpty',
    'inputInvalid',
    {
      pattern: /^\d+(\.\d+)?$/,
      removeZeroCheck: true,
    },
  ),
  // ...FormRulesFactory.generateCustomRules(
  //   ['elecPriceDiscount', 'servicePriceDiscount'],
  //   'discountInfo',
  //   'discountInfo',
  //   {
  //     pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
  //     removeZeroCheck: true,
  //   },
  // ),
  elecPriceDiscount: [
    {
      message: t('formRules.discountInfo'),
      trigger: 'blur',
      required: true,
      pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
    },
  ],
  servicePriceDiscount: [
    {
      message: t('formRules.discountInfo'),
      trigger: 'blur',
      required: true,
      pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
    },
  ],
})

const { GroupTypes, getGroupTypeDesc, PricingDescountInfoTypes, getPricingDescountInfoTypeDesc } =
  useProtocolEnums()


const formData = ref<Partial<Group>>({})
const formRef = ref()


const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const dialogTitle = computed(() => {
  if (props.isEdit) {
    return `${t('Base.edit')}`
  } else {
    return `${t('Base.add')}`
  }
})
const handleOpenDialog = () => {
  nextTick(() => {
    // 清空校验
    formRef.value.clearValidate()
  })
}
watch(showDialog, async (val) => {
  const { enable, global } = formData.value
  if (props.isEdit) {
    formData.value = _.cloneDeep(props.info || {})
    formData.value.enable = enable ? 1 : 0
    formData.value.global = global ? 1 : 0
    console.log(props)
  } else {
    formData.value = {}
  }
})
watch(
  () => formData.value.priceingType,
  (type) => {
    switch (type) {
      case PricingDescountInfoType.PDIT_RATIO:
        groupFormRule.elecPriceDiscount = groupFormRule.servicePriceDiscount = [
          {
            message: t('formRules.discountRatioInfo'),
            trigger: 'blur',
            required: true,
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
          },
        ]
        break
      case PricingDescountInfoType.PDIT_FIXED: {
        groupFormRule = {
          ...groupFormRule,
        }
        break
      }
    }
    console.log(groupFormRule)
  },
)

const submit = async () => {
  try {
    await formRef.value.validate()
    isSubmitting.value = true

    await upsertGroup(formData.value)
    if (props.isEdit) {
      ElMessage.success(t(`Base.updateSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "60%",
    class: "upsert-dialog",
    "z-index": 2000,
    onOpen: handleOpenDialog
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(dialogTitle)), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('Operation.enterpriseGroupLabel')) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Operation.enterpriseGroupDesc')), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('Operation.pricingGroupLabel')) + ": ", 1),
          _createTextVNode(_toDisplayString(_ctx.$t('Operation.pricingGroupDesc')), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('Operation.discountLabel')) + ":", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('Operation.discountDesc')), 1)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[17] || (_cache[17] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: _unref(groupFormRule)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.selectOperator'),
                    prop: "evseOperatorId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: formData.value.evseOperatorId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.evseOperatorId) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.type'),
                    prop: "type",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.type,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.type) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GroupTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.name'),
                    prop: "name",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.phone'),
                    prop: "phone",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        modelValue: formData.value.phone,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.phone) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.priceingType'),
                    prop: "priceingType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.priceingType,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.priceingType) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PricingDescountInfoTypes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }),
              (formData.value.priceingType == _unref(PricingDescountInfoType).PDIT_RATIO)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.elecPriceDiscountInfo'),
                          prop: "elecPriceDiscount"
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.elecPriceDiscount')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.elecPriceDiscount,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.elecPriceDiscount) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.servicePriceDiscountInfo'),
                          prop: "servicePriceDiscount"
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.servicePriceDiscount')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.servicePriceDiscount,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.servicePriceDiscount) = $event)),
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (formData.value.priceingType == _unref(PricingDescountInfoType).PDIT_FIXED)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.sharpElecAmount'),
                          prop: "sharpElecAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.sharpElecAmount,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.sharpElecAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.sharpServiceAmount'),
                          prop: "sharpServiceAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.sharpServiceAmount,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.sharpServiceAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.peakElecAmount'),
                          prop: "peakElecAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.peakElecAmount,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.peakElecAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.peakServiceAmount'),
                          prop: "peakServiceAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.peakServiceAmount,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.peakServiceAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.flatElecAmount'),
                          prop: "flatElecAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.flatElecAmount,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.flatElecAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.flatServiceAmount'),
                          prop: "flatServiceAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.flatServiceAmount,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.flatServiceAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.valleyElecAmount'),
                          prop: "valleyElecAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.valleyElecAmount,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.valleyElecAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.valleyServiceAmount'),
                          prop: "valleyServiceAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.valleyServiceAmount,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.valleyServiceAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.deepValleyElecAmount'),
                          prop: "deepValleyElecAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.deepValleyElecAmount,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.deepValleyElecAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.deepValleyServiceAmount'),
                          prop: "deepValleyServiceAmount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElInput), {
                              type: "number",
                              min: 0,
                              modelValue: formData.value.deepValleyServiceAmount,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.deepValleyServiceAmount) = $event)),
                              modelModifiers: { number: true },
                              placeholder: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})